<template>
    <div>
        <div class="paragraph">
            <div v-if="currentPage == 1">
                <p class="bold">国外防治“白色污染”的有关内容</p>
                <p class="indent">985年，美国人均消费塑料包装物就已达23.4公斤，日本为20.1公斤。九十年代，发达国家人均消费塑料包装物的数量更多（从消费量来看，似乎发达国家的“白色污染”应该很严重，实则不然。究其原因，一是发达国家很早就严抓市容管理，基本消除了“视觉污染”，二是发达国家生活垃圾无害化处置率较高）</p>
                <p class="indent">现在已建立起了一套严密的分类回收系统，大部分废旧塑料包装物被回收利用，少部分转化为能源或以其它方式无害化处置，也基本消除了废旧塑料包装物的潜在危害。</p>
                <p class="indent">美国制定了《资源保护与回收法》，对固体废物管理、资源回收、资源保护等方面的技术研究、系统建设及运行、发展规划等都做出了明确的规定。日本在《再生资源法》、《节能与再生资源支援法》、《包装容器再生利用法》等法律中列专门条款，以促进制造商简化包装，并明确制造者，销售者和消费者各自的回收利用义务。德国在《循环经济法》中明确规定，谁制造、销售、消费包装物品，谁就有避免产生、回收利用和处置废物的义务。</p>
                <p class="indent">我国防治”白色污染“的方法及其利弊分析</p>
                <p class="indent">目前我国开始从行政和技术两个方面采取措施，防治“白色污染”。</p>
                <p class="bold">在行政方面，一是加强管理。</p>
                <p class="indent">禁止使用一次性难降解的塑料包装物。杭州是我国最早禁止使用一次性泡沫快餐具的城市。通过采取上述措施，在一定范围，一定程度上减轻了“白色污染”的危害。但从实践的结果来看，单靠禁止是很难彻底解决“白色污染”问题的，上述颁布禁令的城市都要求用纸制品或可降解塑料制品代替原来的难降解的泡沫塑料制品。但是替代品在价格和品质上均无法与普通塑料制品竞争。因此，在市场经济条件下，仅靠行政命令，不考虑经济杠杆的调节作用，操作起来是很困难的。 </p>
                <p class="indent">强制回收利用。清洁的废旧塑料包装物可以重复使用，或重新用于造粒、炼油、制漆、作建筑材料等。回收利用符合固体废物处理的“减量化、资源化、无害化”的通用原则。回收利用不仅可以避免“视觉污染”，而且可以解决“潜在危害”，缓解资源压力，减轻城市生活垃圾处置负荷，节约土地，并可取得一定的经济效益。</p>
                <p class="indent">在技术方面，一是采取以纸代塑。纸的主要成份是天然植物纤维素，废弃后容易被土壤中的微生物分解，因此可以解决前面所说的“潜在危害”，但也会带来新的环境问题：首先造纸需要大量的木材，而我国的森林资源并不富裕；其次造纸过程中会带来水污染。另外，在性能、成本等方面，纸制品尚不能与塑料制品抗衡。目前，我国也有以甘蔗秆、稻草为原料生产一次性餐具的做法，但尚处于试验阶段。</p>
            </div>
            <div v-if="currentPage == 2">
                <p class="bold">二是采用可降解塑料。</p>
                <p>在塑料包装制品的生产过程中加入一定量的添加剂（如淀粉、改性淀粉或其它纤维素、光敏剂、生物降解剂等），使塑料包装物的稳定性下降，较容易在自然环境中降解。目前，北京地区已有19家研制或生产可降解塑料的单位。试验表明，大多数可降解塑料在一般环境中暴露3个月后开始变薄、失重、强度下降，逐渐裂成碎片。如果这些碎片被埋在垃圾或土壤里，则降解效果不明显。使用可降解塑料有四个不足：一是多消耗粮食；二是使用可降解塑料制品仍不能完全消除“视觉污染”；三是由于技术方面的原因，使用可降解塑料制品不能彻底解决对环境的“潜在危害”；四是可降解塑料由于含有特殊的添加剂而难以回收利用。</p>
                <p class="bold">三是从法律上进行规定。</p>
                <p class="indent">通过相关法律，从2008年6月1日开始，到超市购物将不再免费提供塑料袋，要自己单独付费，这算是希望人们减少塑料袋的使用吧。</p>
                <p class="bold">我国在防治“白色污染”方面存在的主要问题是：</p>
                <p class="indent">1、没有全国性的专门法规</p>
                <p class="indent">防治“白色污染”不能光靠企业或个人的自觉性，应有强制性措施，约束公民和餐饮、交通等行业的工作人员的行为。如，要求企业或个人对自己生产、经营、消费活动中产生的废旧塑料包装物进行回收利用；对随意抛弃、堆放废旧塑料包装物的行为进行处罚等。但迄今为止，我国还没有制定这方面的全国性法规。</p>
                <p class="bold">2、缺少相关的经济政策</p>
                <p class="indent">要调动废旧塑料包装物的回收、加工、利用企业的积极性，需要给予这些企业以优惠政策。现有的综合利用优惠政策尚不足以使废旧塑料包装物回收利用行业形成良性的市场机制。为了不增加政府负担，同时体现“污染者付费”的原则，应要求产生废物者自行回收利用，不能自行回收利用的企业或个人要交纳回收处理费，用于对回收利用者的补偿。这种做法在国外已较为普遍，我国，目前还没有这类经济政策。</p>
                <p class="bold">3、管理工作跟不上</p>
                <p class="indent">城市、风景旅游区、交通干线、水域的“白色污染”主要是管理不力造成的。餐饮、商业、铁路、水运部门对经营活动中产生的废旧塑料包装物没有采取严格的管理措施，听任顾客直接扔在地上或水中，甚至一些工作人员对已收集起来的废物又抛弃到车窗外或水中。城市街道和旅游区的配套设施还不健全，商场、饭店、公园等繁华地段的垃圾箱密度太低，还没有设置分类垃圾箱。市容环卫部门虽有规定禁止乱扔废物，但执法、检查的人员少，有法不依、有禁不止的现象较为普遍。</p>
            </div>
            <div v-if="currentPage == 3">
                <p class="bold">4、管理思想不统一</p>
                <p class="indent">我国相当多的地区对“白色污染”的危害性认识不足，防治“白色污染”问题还未提上议事日程。有的地方主张以纸代塑或使用可降解塑料来解决“白色污染”，有的地区则主张靠回收利用来解决问题，管理思想还不统一。</p>
                <p class="bold">5、人们的环境意识还靠进一步提高</p>
                <p class="indent">城市居民的环保观念虽比前几年有所提高，开始关注环境问题，但还没有落实到自身的行动上，随手抛弃废物，乱倒、乱堆废旧塑料包装物的行为随处可见。新闻媒介对“白色污染”的报导大多集中在以纸代塑和采用可降解塑料等技术方面，缺少对居民日常行为的引导教育。塑料包装物的生产、经营单位和消费者没有责任感，既没有履行义务的内在动力，也没有回收、利用、处置废旧塑料包装物的外部压力。</p>
                <p class="bold">6、停止使用一次性餐具及超薄塑料袋。</p>
                <p class="indent">由于一次性塑料餐具难降解，现在许多城市都推广使用绿色餐具——纸制餐具，因为纤维素能被微生物降解。但许多环保专家认为，用纸制餐具代替发泡塑料餐具亦不明智。首先，纸制餐具同样也会带来视觉上的污染，因为它们的降解速度并不快，往往在几十天甚至几个月内也不会降解彻底。其次，制纸制餐具时，除用到草浆、稻浆外，还要加入1/3左右的木浆，若全面推广，势必造成大量木材的消耗，导致森林砍伐的加剧。值得注意的是，我国森林覆盖率仅为13.92%，人均占有森林面积只相当于世界人均水平的17.2%，居世界112位。第三，制纸浆历来是耗水大户、耗能大户及排污大户。造浆工艺需大量水，而我国人均水的占有量在世界上排88位，已被列为世界12个贫水国家的名单上；若污水未经处理，直接排入河流中，会引起水污染；纸制餐具成型后需立即烘干，这就需要耗大量能。而我国能源结构是以燃煤为主，这样就会增加空气中SO2的含量，引起酸雨。因此，无论是从环保角度，还是从节约资源角度，不使用一次性塑料餐具及纸制餐具都是一件好事。任何一次性餐具不仅不利于环保，也是对资源的最大的浪费。我们在日常生活中，应拒绝使用超薄塑料袋买菜或盛装食物，买菜可用菜篮子或较厚塑料袋，避免使用上的一次性，从而减少塑料袋对环境的污染。</p>
                <p class="bold">7、回收废塑料并使之资源化是解决白色污染的根本途径。</p>
                <p class="indent">其实，塑料和其它材料比，有一个显著的优点：塑料可以很方便地反复回收使用。废塑料回收后，进行分类、清洗后再通过加热熔融，即可重新成为制品。从组成看，聚乙烯、聚丙烯、聚苯乙烯均由碳氢元素组成，而汽油、柴油等燃料也是由碳氢元素组成，只不过分子量较小。因此，把这几类塑料隔绝空气加热至高温，</p>
            </div>
            <div v-if="currentPage == 4">
                <p>近年来，一些国家大力开展3R运动：即要求做到废塑料的减量化（Reduce）、再利用（Reuse）、再循环（Recycle）。目前，在德、日、美等国家，由于重视对包装材料的回收处理，已经实现了塑料的生产、使用、回收、再利用的良性循环，从根本上消除了白色污染。</p>
                <p class="bold">8、研究开发降解塑料。</p>
                <p class="indent">降解塑料具有与普通塑料同样的使用功能，但在完成其使用功能而被废弃后，其化学结构可以在某些条件下发生变化，使高分子分解成分子量较小的分子，最后，被自然环境所同化。降解塑料有三类：光降解塑料、生物降解塑料及双降解塑料。但是现在许多降解塑料并非100%降解，只是把塑料变为塑料碎片，据报道，我国陕西杨凌农业高新技术产业示范区已研制成功100%降解的塑料。它是将淀粉和不可降解的塑料通过特殊设备粉碎成纳米级后进行物理结合，再将两者比例控制在一定范围内。用这种新技术生产的农用地膜，经过四至五年的大田试验，结果显示，在70天至90天内，淀粉完全降解为H2O、CO2，塑料变为对土壤和空气无害的细小颗粒，并在17个月内同样完全降解为H2O、CO2。现在这种塑料已投入批量生产。目前在世界上降解塑料还远远没有得到大规模使用。开发使用降解塑料也只能作为解决白色污染的辅助措施。</p>
                <p class="bold">9、加强环保宣传，提高公民的环保意识。</p>
                <p class="indent">在社会上形成良好的环保氛围，是解决白色污染及其它各种形式污染的前提。例如，要回收废塑料，就要实行垃圾回收分装制度，把不同类的垃圾放在不同的垃圾桶内，这就需要我们有高度自觉的环保意识。</p>
            </div>
        </div>
        <div class="link-content">
            <div class="bottom margin-left">
                <div class="image-col float-left">
                    <img src="../../../assets/images/wenben.jpg" />
                </div>
                <div class="text-col float-left"><span><span class="sp-text">页码: </span></span> <span :class="{ active: currentPage == 1 }" class="page" @click="currentPage = 1">1</span> <span class="sp-text">-</span> <span :class="{ active: currentPage == 2 }" class="page" @click="currentPage = 2">2</span> <span class="sp-text">-</span> <span :class="{ active: currentPage == 3 }" class="page" @click="currentPage = 3">3</span> <span class="sp-text">-</span> <span :class="{ active: currentPage == 4 }" class="page" @click="currentPage = 4">4</span>&nbsp;&nbsp;&nbsp;<span class="sp-text">-</span></div>
                <div class="image-col float-left no-left">
                    <img style="cursor: pointer" @click="back" src="../../../assets/images/return.jpg" />
                </div>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WhitePollutionPrevent",
        data() {
            return {
                currentPage: 1
            }
        },
        methods: {
            back() {
                this.$emit('onIndexChanged',1);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .paragraph {
        .red {
            color: #ff0000;
        }
        .margin-top {
            margin-top: 20px;
        }
        p {
            font-size: 13px;
            color: #800000;
        }
    }
    .link-content {
        margin-top: 2%;
        margin-left: 10%;
        width: 80%;
        .bottom {
            float: left;
            width: 100%;
            height: 80px;
            margin-left: 50px;
            .float-left {
                float: left;
            }
            .image-col {
                height: 30px;
                margin-left: 15px;
                &.no-left {
                    margin-left: 5px;
                }
            }
            .text-col {
                margin-left: 15px;
            }
            img {
                width: 25px;
                height: 25px;
            }
            .margin-left {
                margin-left: 40%;
            }
            a, span {
                font-size: 15px;
                color: #000000;
                text-decoration: none;
                cursor: pointer;
                &.sp-text {
                    color: #cbf8e2;
                }
            }
            .page {
                padding: 3px 8px;
                border: 1px #aaa solid;
                background: #eee;
                box-shadow: -1px -1px 2px #ccc inset;
                font-weight: bold;
                &.active {
                    background: #4a97d4;
                    border: 1px #175187 solid;
                    color: #fff;
                    box-shadow: -1px -1px 2px #7894bd inset;
                }
            }
        }

    }
</style>